<template>
  <div class="management">
    <div class="management__container">
      <div class="management__row">
        <div v-if="showDynamicMenu" class="floating-menu">
          <DynamicMenu :menu-items="dynamicMenuItems" :current-slug="linksDepartment"/>
        </div>
        <div class="management__content">
          <div class="management__title">
          <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase left">Руководство</h1>
          </div>
          <template v-if="chiefOfficers.length">
          <div class="people-block" v-for="main in chiefOfficers" :key="main.id" >
            <div class="people-block__img">
              <img :src="main.imageThumb || main.image" :alt="main.name">
            </div>
            <div class="people-block__information">
              <div class="people-block__information-header">
                <p class="text-TTDrugs-bold-20 text-uppercase color-gray">{{main.name}}
                </p>
              </div>
              <div class="people-block__information-position">
                <p class="color-black text-TTDrugs-regular-20 text-uppercase">{{ main.position }}</p>
              </div>
              <div
                class="people-block__information-position people-block__information-position--qualification"
                v-if="main.qualificationCategory || main.qualification_category || main.category"
              >
                <p class="color-black text-TTDrugs-light-18">
                  {{ main.qualificationCategory || main.qualification_category || main.category }}
                </p>
              </div>
              <div
                class="people-block__information-position"
                v-if="main.academicDegree || main.academic_degree"
              >
                <p class="color-black text-TTDrugs-light-18">
                  {{ main.academicDegree || main.academic_degree }}
                </p>
              </div>

              <div class="people-block__information-opening-hours" v-if="main.openingHours">
                <p class="text-circe-20"><span class="text-circe-bold-20">Часы приёма:</span> {{main.openingHours}}</p>
              </div>
            </div>
          </div>
          </template>
        </div>
      </div>
      <template v-if="managementList.length">
      <app-people-list :managements="managementList" />
      </template>
    </div>

  </div>
</template>

<script>
import AppPeopleList from '@/components/People/PeopleList.vue'
import {mapState} from 'vuex'
import {actionTypesDepartment} from '@/store/modules/department'
import DynamicMenu from "@/components/DynamicMenu.vue";
import menuItemsApi from "@/api/menuItems";

function isDeputyPosition(position) {
  return String(position || '').toLowerCase().includes('заместител');
}

function mapForPeopleList(person) {
  return {
    ...person,
    opening: person.openingHours || person.opening || '',
  };
}

export default {
    name: "AppManagement",
    components: {
      DynamicMenu,
      AppPeopleList,
    },
    metaInfo() {
      return {
        title: 'Руководство | Алтайский краевой клинический перинатальный центр ДАР',
        meta: [
          {
            name: 'description',
            content: 'Руководство. Подробная информация о Алтайском краевом клиническом перинатальном центре ДАР.'
          },
          {
            name: 'keywords',
            content: 'Алтайский краевой клинический перинатальный центр'
          }
        ]
      };
    },
    computed: {
      ...mapState({
        isLoading: (state) => state.department.isLoading,
        MANAGEMENTS: (state) => state.department.MANAGEMENTS,
        CHIEF_MEDICAL_OFFICER: (state) => state.department.CHIEF_MEDICAL_OFFICER,
      }),
      chiefOfficers() {
        return (this.CHIEF_MEDICAL_OFFICER || []).filter(
          (person) => !isDeputyPosition(person.position)
        );
      },
      deputies() {
        const fromChief = (this.CHIEF_MEDICAL_OFFICER || []).filter((person) =>
          isDeputyPosition(person.position)
        );
        const fromManagement = (this.MANAGEMENTS || []).filter((person) =>
          isDeputyPosition(person.position)
        );
        return [...fromChief, ...fromManagement].map(mapForPeopleList);
      },
      heads() {
        return (this.MANAGEMENTS || [])
          .filter((person) => !isDeputyPosition(person.position))
          .map(mapForPeopleList);
      },
      managementList() {
        return [...this.deputies, ...this.heads];
      },
      showDynamicMenu() {
        return this.dynamicMenuItems && this.dynamicMenuItems.length > 0;
      }
    },
    data() {
      return {
        linksDepartment: 'about/management',
        dynamicMenuItems: [],
      };
    },
    methods: {
      fetchGetAllDoctors() {
        this.$store.dispatch(actionTypesDepartment.getAllDoctors)
      },
      async loadSiblingsForMenu() {
        try {
          const response = await menuItemsApi.getSiblingsByTo('/about/management');

          if (response.data.status === "SUCCESS") {
            this.dynamicMenuItems = response.data.result
                .map(item => {
                  const slug = item.to.startsWith('/') ? item.to.substring(1) : item.to;

                  return {
                    text: item.label,
                    link: item.to,
                    slug: slug,
                    active: slug === this.currentPath,
                    id: item.id,
                    order: item.order || 0
                  };
                })
                .sort((a, b) => (a.order || 0) - (b.order || 0));
          }
        } catch (error) {
          console.error('Ошибка при загрузке меню:', error);
        }
      }
    },
    mounted() {
      this.fetchGetAllDoctors()
      this.loadSiblingsForMenu();
    }
  };
</script>

<style scoped>

</style>
